module.exports = __webpack_public_path__ + "static/media/translate-selected-icon.3565672f.png";